import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const userToken = localStorage.getItem('userToken');

  return userToken ? children : <Navigate to="/" />;
};

export default PrivateRoute;